import React from 'react';
import { Element, scroller } from 'react-scroll';

import { GetStaticPaths, GetStaticProps } from 'next';
import usei18n, { getLocalePaths } from '@i18n';
import PresentBlock from '@pages/telegram-bot/PresentBlock';
import AdvantagesBlock from '@pages/telegram-bot/AdvantagesBlock';
import RolesBlock from '@pages/telegram-bot/RolesBlock';
import MyAccountsBlock from '@pages/telegram-bot/MyAccountsBlock';
import config from '@config/auth.json';
import useRefreshToken from '@hooks/useRefreshToken';
import { CustomGetStaticPathsResult, CustomGetStaticPropsResult } from '../../../types';

const TelegramBotPage: React.FC = () => {
    const auth = useRefreshToken();
    const { locale } = usei18n();
    const redirect = (href, fallback = true) => (): void => {
        const localeHref = href.replace(/:locale/, locale);
        window.location.href = fallback
            ? `${localeHref}?redirect_url=${window.location.href}`
            : localeHref;
    };

    const goAuth = redirect(config.AUTH_URL);

    return (
        <div className="flex flex-col items-center px-0 xs:px-[8px] sm:px-[16px]">
            <PresentBlock
                auth={auth}
                goToCopyLink={() =>
                    scroller.scrollTo('RolesBlock', {
                        duration: 400,
                        smooth: true,
                        offset: 50,
                    })
                }
                goAuth={goAuth}
                goReg={redirect(config.REG_URL)}
            />
            <AdvantagesBlock />
            <Element name="RolesBlock">
                <RolesBlock auth={auth} goAuth={goAuth} />
            </Element>
            <MyAccountsBlock auth={auth} goAuth={goAuth} />
        </div>
    );
};

export const getStaticProps: GetStaticProps = async ({
    params,
}): Promise<CustomGetStaticPropsResult> => {
    return { props: { locale: params?.locale } };
};

export const getStaticPaths: GetStaticPaths = async (): Promise<CustomGetStaticPathsResult> => {
    return { paths: getLocalePaths(), fallback: false };
};

export default TelegramBotPage;
